import React, { EventHandler, useContext, useEffect, useState } from "react";
import "./Indicator.scss";
import { ThemeContext } from "../../store/ThemeProvider";
import { getPendantColor } from "../../utils/color";
import ReactSVG from "react-svg";
import { IOneGallery } from "../GalleryList/Common";
import uColumn2List from "../GalleryList/useColumn2List";
import { debounce } from "../../utils/util";
import intl from "react-intl-universal";
import { PageContext} from "../ComponentNavigatorV2/PageContext";

interface IIndicator {
  total: number;
  mode: string;
  loadedTotal: number;
  // tagRefTop: number;
  // list?: IOneGallery[];
  // top: number;
}

const Index = (props:IIndicator)=>{
  const {total, mode, loadedTotal} = props;

  const { backgroundColor } = useContext(ThemeContext);
  const [pendantBgColor, pendantIconColor] = getPendantColor(backgroundColor);
  const [mainWrapper, setMainWrapper] = useState(null as HTMLDivElement | null);
  const [pageTopWrapper, setPageTopWrapper] = useState(null as HTMLDivElement | null);

  const context = useContext(PageContext);
  useEffect(()=>{
    if(context.cid) {
      setMainWrapper(window.document.querySelector('.decorate-container')! as HTMLDivElement);
      setPageTopWrapper(window.document.getElementById(`page-top-${context.cid}`)! as HTMLDivElement);
    }
  }, [context.cid]);

  const scrollToTop = ()=>{
    if(mainWrapper) {
      mainWrapper.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    }
  };

  const [number, setNumber] = useState(-1);
  const [isMoving, setIsMoving] = useState(false);
  const [show, setShow] = useState(false);

  useEffect(()=>{
    const onScroll = ()=>{
      if(mainWrapper && pageTopWrapper) {
        let targetX = mainWrapper.offsetLeft + 50;
        let targetY = pageTopWrapper.offsetHeight + 50;

        const {offsetHeight, scrollHeight, scrollTop} = mainWrapper;

        if((offsetHeight + scrollTop) >= (scrollHeight - 50)) {
          // 此处应该显示的是当前已加载图片的总数
          setNumber(loadedTotal);
        }else {
          let target = window.document.elementFromPoint(targetX, targetY) as HTMLElement;
          if(target) {
            // 查一下
            let index = target.getAttribute('data-index');
            if(Number(index)) {
              setNumber(Number(index));
            }else {
              setNumber(-1);
            }
          }
        }
      }
    };

    

    window.addEventListener(`page-scroll-move-${context.cid}`, onScroll);
    
    return ()=>{
      window.removeEventListener(`page-scroll-move-${context.cid}`, onScroll);
    }
  }, [mainWrapper, pageTopWrapper, isMoving]);

  useEffect(()=>{
    if(number > 0) {
      setShow(true);
    }else {
      setShow(false);
    }
  }, [number]);

  useEffect(()=>{
    let timer = 0;
    if(number > 0) {
      setIsMoving(true);
      timer = window.setTimeout(()=>{
        setIsMoving(false)
      }, 800);
    }

    return ()=>{
      window.clearTimeout(timer);
    }
  }, [number]);

  return show ? (
    <div
      className="gallery-indicator"
      style={{
        color: pendantIconColor,
        backgroundColor: pendantBgColor,
        // top: props.top,
      }}
      onClick={scrollToTop}
    >
      {isMoving ? (
        `${Math.max(1, number)}/${props.total || 0}`
      ) : (
        <>
          <div>{intl.get("To top")}</div>
          <ReactSVG
            src={require("../../svg/double-up-arrow.svg")}
            className={"db-arrow"}
          />
        </>
      )}
    </div>
  ) : null;
}

export default Index;